export enum FeatureEnum {
  isLinearPlayoutToggleEnabled = 'LINEAR_PLAYOUT_TOGGLE',
  isSubscriptionsToggleEnabled = 'SUBSCRIPTIONS_TOGGLE',
  isAudioSegmentToggleEnabled = 'AUDIO_SEGMENT_TOGGLE'
}
